







import { Vue, Component, Prop } from 'vue-property-decorator';
import GNoDataSpan from '@/components/GNoDataSpan.vue';

@Component({
  name: 'GOptionalData',
  components: { GNoDataSpan },
  computed: {},
  methods: {},
})
export default class GOptionalData extends Vue {
  @Prop() condition: boolean;
  mounted() {}
}
